import gql from 'fraql'
export default {
  statsOrder: gql`query StatisticsOrder ($dateFrom: Datetime, $dateTo: Datetime, $idRestPoint: Int, $idTypeDelivery: Int) {
    statsStageOrder (dateFrom: $dateFrom, dateTo: $dateTo, idRestPoint: $idRestPoint, idTypeDelivery: $idTypeDelivery) {
      nodes {
        stageName
        idStage
        timeAvg {
          years
          months
          days
          hours
          minutes
          seconds
        }
      }
      totalCount
    }
  }`,
  statsWorkshop: gql`query StatisticsWorkshop ($dateFrom: Datetime, $dateTo: Datetime, $idTypeWorkshop: Int, $idRestPoint: Int, $idTypeDelivery: Int) {
    statsStageWorkshop (dateFrom: $dateFrom, dateTo: $dateTo, idTypeWorkshop: $idTypeWorkshop, idRestPoint: $idRestPoint, idTypeDelivery: $idTypeDelivery) {
      nodes {
        stageName
        stageKeyword
        timeAvg {
          years
          months
          days
          hours
          minutes
          seconds
        }
      }
      totalCount
    }
  }`,
  typesWorkshop: gql`query {
    allTypeWorkshops {
      nodes {
        id,
        name
      }
    }
  }`,
  restPoints: gql`
    query {
     allRestPoints(condition: {active: true}) {
       nodes {
         id,
         address
       }
     }
    }
  `,
  deliveryTypes: gql`
  query {
    allTypeDeliveries {
     nodes {
       id,
       name
     }
   }
  }
`,
  workers: gql`
    query Workers($position: String) {
     allWorkers(condition: {active: true, keywordPos: $position}, orderBy: LAST_NAME_ASC) {
       nodes {
         id,
         firstName,
         lastName,
         secondName
       }
     }
    }
  `,
  workerCallCenterStats: gql`
    query statsWorker ($idWorker: Int, $dateFrom: Datetime, $dateTo: Datetime) {
      statsWorkerCallcenter(idworker: $idWorker, dateFrom: $dateFrom, dateTo: $dateTo) {
        nodes {
          date
          idOrder
          orderSum
          price
          priceMotivate
          productCount
          isRestManager
        }
      }
    }
  `,
  cookerMotivateStats: gql`
    query calcCookerMotivate ($dateFrom: Date!, $dateTo: Date!, $idWorker: Int) {
      calcCookerMotivate (dateFrom: $dateFrom, dateTo: $dateTo, idWorkerParam: $idWorker) {
        nodes {
          restPoint
          date
          timeOpened
          timeClosed
          hoursOnWork
          sumFromHours
          percentTarget
          percentReward
          sumPercentageOfTurnover
          turnover
          hour
          totalWorkersHoursByPointDay
          hourlyRate
          secondsOnWork
        }
      }
    }
  `,
  timeOrderStats: gql`
    query getStatsTimeOrder (
      $dateTo: Datetime!,
      $dateFrom: Datetime!,
      $idRestPoint: Int,
      $idTypeDelivery: Int
    ) {
      getStatsTimeOrder(dateTo: $dateTo, dateFrom: $dateFrom, idRestPoint: $idRestPoint, idTypeDelivery: $idTypeDelivery) {
        nodes {
          timeTo
          count
          sum
        }
      }
    }
  `
}



// WEBPACK FOOTER //
// ./src/constants/graphqlStats.js